import axios from "axios"
import { ACTIVE_TAB, LOADER_STATUS,FILE_DATA, COMP_DATA } from "./constants";
import { getLocalStorage } from "components/Helper/Helper";
import { Config } from "../../../Config.js";
import { toast } from "react-toastify";
async function errorNot(errMsgVal) {
  await toast.success(`${errMsgVal}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}

async function errorNotErr(errMsgVal) {
  toast.error(`${errMsgVal}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}
const handlemonth=(value)=> {
  const dateString = value;
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Month is zero-based, so we add 1
  let temp =month < 10 ? 0 + month.toString() : month
  const resultDate =   temp.toString()+year.toString();
  return resultDate;
}
export function loader(status) {
    return {
      type: LOADER_STATUS,
      loaderStatus: status,
    };
}

export function setPrepareData(fileData) {
    return {
      type: FILE_DATA,
      fileData: fileData,
    };
  }
  export function setComparativeData(compData) {
    return {
      type: COMP_DATA,
      compData: compData,
    };
  }  
export function getPreviewTableData(selectedGSTIN, startDate, endDate,isSaveToGstin=false) {
    return (dispatch) => {
        dispatch(loader(true));
        let rpt_from = handlemonth(startDate);
        let rpt_to = handlemonth(endDate);
        let data = {
          rpt_from: rpt_from,
          rpt_to: rpt_to,
          gstin: selectedGSTIN.join(','),
          isSaveToGstin
        };
        
        return new Promise((resolve, reject) => {
          axios({
            method: "post",
            url: `${Config.url}itc04/getSummary`,
            data: data,
            headers: {
              token: getLocalStorage("loginDetails"),
            },
        })
        .then((response) => {
            if(response.data.error == 0){              
              dispatch(setPrepareData(response.data.data));              
              resolve(response.data.data);
            }else {
              errorNotErr(response.data.message);             
              resolve([]);
              dispatch(setPrepareData([]));
            }
            dispatch(loader(false))
            ;
          })
          .catch((error) => {
            dispatch(loader(false));
            console.log(error);
            reject(true);
            });
        });
      };
  };

  export const saveToGstn = (selectedGSTIN, startDate, endDate) => {
    let rpt_from = handlemonth(startDate);
  let rpt_to = handlemonth(endDate);
  let data = {
    rpt_from: rpt_from,
    rpt_to: rpt_to,
    gstin: selectedGSTIN.join(','),
  };
    return (dispatch) => {
      dispatch(loader(true));
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          data: data,
          url: `${Config.url}itc04/saveGstn`,
          headers: {
            token: getLocalStorage("loginDetails"),
          },
        })
          .then((response) => {
            if (response.data.error != 1) {
              errorNot(response.data.message);              
              dispatch(getPreviewTableData(selectedGSTIN, startDate, endDate,true))
              resolve(true);
              
            } else {
              errorNotErr(response.data.message);             
              resolve(false);
            }
            dispatch(loader(false));
          })
          .catch((error) => {
            dispatch(loader(false));
            console.log(error);
            reject(true);
          });
      });
    };
  };
  export function getComparativeTableData(selectedGSTIN,startDate, endDate) {
    let rpt_from = handlemonth(startDate);
  let rpt_to = handlemonth(endDate);
      return (dispatch) => {
          dispatch(loader(true));
         let data = {
          gstin:selectedGSTIN?.join(','),
          rpt_to: rpt_to,
          rpt_from:rpt_from ,
         }
      
          return new Promise((resolve, reject) => {
            axios({
              method: "post",
              url: `${Config.url}itc04/getcomparative_view`,
              data: data,
              headers: {
                token: getLocalStorage("loginDetails"),
              },
          })
          .then((response) => {
              if(response.data.error == 0){
                errorNot("Fetched Successfully");                                               
                dispatch(setComparativeData(response.data.data));                
                resolve(response.data.data);
              }else {
                errorNotErr(response.data.message);
                resolve([]);
                dispatch(setComparativeData([]));
              }
              dispatch(loader(false))
              ;
            })
            .catch((error) => {
              dispatch(loader(false));
              console.log(error);
              reject(true);
              });
          });
        };
    };